import React from 'react';
import { colors } from '../config';

const OfferOption = ({
  installments,
  price,
  total,
  rate,
  single,
  isPersonalBank = false,
  ...rest
}) => (
  <div className="wrap" {...rest}>
    {!single && (
      <div className="main">
        {installments} cuotas <span>de</span> {price}
      </div>
    )}

    {single && <div className="main">{single}</div>}
    <div className="total">{total}</div>
    <div className="rate">
      T.E.A.: <strong>{rate}</strong>
    </div>

    <style jsx>{`
      .main {
        color: ${isPersonalBank ? `#000066` : colors.orange};
        font-size: 26px;
        font-weight: bold;
        line-height: 1.125;
        margin-bottom: 4px;
      }

      .main span {
        font-weight: 500;
      }

      .total {
        font-weight: bold;
        font-size: 20px;
        color: #252220;
        line-height: 1.25;
      }

      .rate {
        font-size: 15px;
        color: #56504c;
      }

      .wrap {
        padding-left: 8px;
      }
    `}</style>
  </div>
);

export default OfferOption;
